export class LuxAiRequestError extends Error {
	originalMessage: string
	constructor(message: string, originalMessage: string) {
		super(message)
		this.originalMessage = originalMessage
	}
}

export class MissingError extends LuxAiRequestError {} // The requested flow wasn't found
export class InvalidStateError extends LuxAiRequestError {} // The resource is not in a valid state for the requested operation
export class FailedRenderError extends LuxAiRequestError {} // The scene creation step failed
export class CancelFailureError extends LuxAiRequestError {} // The flow is not in a cancel-able state
export class CompleteFailureError extends LuxAiRequestError {} // The flow is not in a complete-able state
export class NotEnoughTokensError extends LuxAiRequestError {} // The user doesn't have enough tokens to generate the selected theme
export class FailedGenerationError extends LuxAiRequestError {} // The LuxLabs execution failed
export class OngoingGenerationsError extends LuxAiRequestError {} // The user already has too many ongoing flows
export class FreeThemeAlreadyGeneratedError extends LuxAiRequestError {} // The free theme has already been generated by this user
